module.exports = __webpack_public_path__ + "front/img/29.3703987a.png";